const Info = (props) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M13 18H11V10H13V18Z' fill='#558B2F' />
    <path d='M13 8H11V6H13V8Z' fill='#558B2F' />
  </svg>
);

export default Info;
